import { render, staticRenderFns } from "./SettingHomepageCategoryNew.vue?vue&type=template&id=3c6e050b&"
import script from "./SettingHomepageCategoryNew.vue?vue&type=script&lang=js&"
export * from "./SettingHomepageCategoryNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports